import {FormControl, FormHelperText, MenuItem, Select} from "@mui/material"
import React from "react"
import {getOptions} from "../../../../anwendungskonfigurator/misc/widget-functions"
import _ from "lodash"

// Aus uwpplus-frontend migriert. Anpassung an VW: getDataFromPointer kommt als Prop
// (statt useContext), getOptions aus dem anwendungskonfigurator-Submodul.
const ListEnumSelectWidget = ({widget, value, onValueChange, disabled, getDataFromPointer}) => {
    const enumEntries = getOptions(widget)

    const onSelectChange = (event) => {
        const newValue = enumEntries?.find((option) =>
            _.isEqual(option.label, event.target.value),
        )
        onValueChange(newValue.value)
    }

    const getDisplayValue = (val) => {
        return enumEntries?.find((option) => _.isEqual(option.value, val))
            ?.label
    }
    const displayValue = getDisplayValue(value)
    const options = widget.path
        ? _.uniq(getDataFromPointer(widget.path))
        : []
    return (
        <FormControl fullWidth>
            <Select
                id={widget.id}
                value={displayValue || ""}
                onChange={onSelectChange}
                className={widget.className}
                disabled={disabled || options?.length === 0}>
                {Array.isArray(options) &&
                    options.map((option, index) => (
                        <MenuItem
                            key={index}
                            value={getDisplayValue(option)}
                            disabled={option?.disabled}>
                            {getDisplayValue(option)}
                        </MenuItem>
                    ))}
            </Select>
            {widget.helperText && (
                <FormHelperText>{widget.helperText}</FormHelperText>
            )}
        </FormControl>
    )
}

export default ListEnumSelectWidget
